// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"37d204e7","885":"606e0386"}[chunkId] + ".chunk.js";
};